'use client';

import React__default, { useContext, useMemo } from 'react';
import { DropdownFooterWrapper } from './DropdownFooter.css.js';
import Button from '../../../Button/index.js';
import { CascaderContext } from '../../context/reducer.js';
import { ACTIONS } from '../../context/actions.js';

var DropdownFooter = function () {
    var _a = useContext(CascaderContext), props = _a.props, state = _a.state, t = _a.t, dispatch = _a.dispatch;
    var onCancel = props.onCancel, onConfirm = props.onConfirm, onBlur = props.onBlur, isMobile = props.isMobile, langCode = props.langCode, selectOptions = props.selectOptions, styleOptions = props.styleOptions, textOptions = props.textOptions;
    var value = state.value, isShow = state.isShow, temporaryValue = state.temporaryValue;
    var onClickCancel = function () {
        onCancel && onCancel(value);
        dispatch({
            type: ACTIONS.ON_CANCEL
        });
    };
    var onClickSearch = function () {
        onConfirm && onConfirm(temporaryValue);
        onBlur && onBlur();
        dispatch({
            type: ACTIONS.ON_CONFIRM
        });
    };
    return useMemo(function () { return (React__default.createElement(DropdownFooterWrapper, { "data-cname": 'dropdown__footer', isShow: isShow, isMobile: isMobile, isSingleSelect: selectOptions.isSingleSelect },
        styleOptions.isShowSecondaryBtn && (React__default.createElement(Button, { type: styleOptions.secondaryBtnType, "data-btn-type": 'secondary', onClick: onClickCancel }, textOptions.secondaryBtnText && textOptions.secondaryBtnText !== ''
            ? textOptions.secondaryBtnText
            : t('Cancel'))),
        !selectOptions.isSingleSelect && (React__default.createElement(Button, { type: styleOptions.primaryBtnType || 'primary', "data-btn-type": 'primary', onClick: onClickSearch }, textOptions.primaryBtnText && textOptions.primaryBtnText !== ''
            ? textOptions.primaryBtnText
            : t('Search'))))); }, [temporaryValue, isShow, value, langCode, isMobile]);
};

export { DropdownFooter as default };
//# sourceMappingURL=index.js.map
